export default __webpack_public_path__ + "static/media/sport-bg.6782ed0a.webp";